import React from 'react';
import PropTypes from 'prop-types';

/**
 * Notification - A wrapper that renders a standard HTML div with Bulma notification class names
 * 
 * This component accepts the same props as Bloomer Notification for easy migration
 */
const Notification = ({
  className,
  style,
  isColor,
  isSize,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['notification'];
    
    // Add appropriate classes based on props
    if (isColor) {
      classes.push(`is-${isColor}`);
    }
    
    if (isSize) {
      classes.push(`is-${isSize}`);
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <div 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

Notification.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isColor: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger', 'light', 'dark', 'white', 'black']),
  isSize: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.node
};

Notification.defaultProps = {
  className: '',
  style: {},
  isColor: null,
  isSize: null,
  children: null
};

export default Notification;
